module.exports = __webpack_public_path__ + "media/images/online-druckerei-printworld-1c-01d084aa06120d68f25370d14354e4c4.png";